<template>
    <div class="box-page">
        <div class="page-header with-underline">
            <div class="d-flex align-items-center justify-content-center">
                <span class="page-title">แก้ไขรูปภาพเอกสาร</span>
            </div>
        </div>

        <div class="container text-center">
            <div class="row">
                <div class="col-md-12">
                    <div><label>บัตรประชาชนตัวจริง</label></div>
                    <img :src="member.imgIdCard" class="img-member mt-2 cursor-pointer" @click="openImg(member.imgIdCard)">
                    <input type="file" ref="fileIdCard" @change="previewFiles($event, 'idCard')" :disabled="isUploading" accept="image/x-png,image/jpeg" style="display:none;">
                    <div class="mt-2">
                        <label class="btn btn-small rounded-pill m-0" :class="{'disabled': isUploading}" @click="$refs.fileIdCard.click()">
                            <template v-if="isUploading">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            </template>
                            <template v-else v-text="getTextToBtnUpload(member.imgIdCard)">อัพโหลดรูป</template>
                        </label>
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-md-12">
                    <div><label>สมุดบัญชีเงินฝาก</label></div>
                    <img :src="member.imgBookBank" class="img-member mt-2" @click="openImg(member.imgBookBank)">
                    <input type="file" ref="fileBookBank" @change="previewFiles($event, 'bookBank')" :disabled="isUploading" accept="image/x-png,image/jpeg" style="display:none;">
                    <div class="mt-2">
                        <label class="btn btn-small rounded-pill m-0" :class="{'disabled': isUploading}" @click="$refs.fileBookBank.click()">
                            <template v-if="isUploading">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            </template>
                            <template v-else v-text="getTextToBtnUpload(member.imgBookBank)">อัพโหลดรูป</template>
                        </label>
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-md-12">
                    <div><label>รูปตัวเองคู่บัตรประชาชน</label></div>
                    <img :src="member.imgAvatar" class="img-member mt-2" @click="openImg(member.imgAvatar)">
                    <input type="file" ref="fileAvatar" @change="previewFiles($event, 'avatar')" :disabled="isUploading" accept="image/x-png,image/jpeg" style="display:none;">
                    <div class="mt-2">
                        <label class="btn btn-small rounded-pill m-0" :class="{'disabled': isUploading}" @click="$refs.fileAvatar.click()">
                            <template v-if="isUploading">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            </template>
                            <template v-else v-text="getTextToBtnUpload(member.imgAvatar)">อัพโหลดรูป</template>
                        </label>
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-md-12">
                    <div><label>รูปถ่ายสลิปค่าสมัคร 100 บาท</label></div>
                    <img :src="member.imgBankSlip" class="img-member mt-2" @click="openImg(member.imgBankSlip)">
                    <input type="file" ref="fileBankSlip" @change="previewFiles($event, 'bankSlip')" :disabled="isUploading" accept="image/x-png,image/jpeg" style="display:none;">
                    <div class="mt-2">
                        <label class="btn btn-small rounded-pill m-0" :class="{'disabled': isUploading}" @click="$refs.fileBankSlip.click()">
                            <template v-if="isUploading">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            </template>
                            <template v-else v-text="getTextToBtnUpload(member.imgBankSlip)">อัพโหลดรูป</template>
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div class="container text-center" v-if="!isPersonal">
            <div class="row">
                <div class="col-md-12">
                    <div><label>หนังสือรับรองเอกสารนิติบุคคล</label></div>
                    <img src="/goobank_assets/assets/default-pdf-uploaded.png" class="img-member mt-2 cursor-pointer" @click="openPDF(member.imgCorpCert)">
                    <input type="file" ref="fileCorpCert" @change="previewPDFs($event, 'corpCert')" :disabled="isUploading" accept="application/pdf" style="display:none;">
                    <div class="mt-2">
                        <label class="btn btn-small rounded-pill m-0" :class="{'disabled': isUploading}" @click="$refs.fileCorpCert.click()">
                            <template v-if="isUploading">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            </template>
                            <template v-else v-text="getTextToBtnUpload(member.imgCorpCert)">อัพโหลด PDF</template>
                        </label>
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-md-12">
                    <div><label>เอกสารแต่งตั้งตัวแทนนิติบุคคล</label></div>
                    <img src="/goobank_assets/assets/default-pdf-uploaded.png" class="img-member mt-2" @click="openPDF(member.imgDocJur)">
                    <input type="file" ref="fileDocJur" @change="previewPDFs($event, 'docJur')" :disabled="isUploading" accept="application/pdf" style="display:none;">
                    <div class="mt-2">
                        <label class="btn btn-small rounded-pill m-0" :class="{'disabled': isUploading}" @click="$refs.fileDocJur.click()">
                            <template v-if="isUploading">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            </template>
                            <template v-else v-text="getTextToBtnUpload(member.imgDocJur)">อัพโหลด PDF</template>
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <div class="text-center">
            <div class="mt-3">
                <button class="btn btn-small" @click="updateDocument">บันทึก</button>
                <button class="btn btn-small" @click="hideEditDoc">ย้อนกลับ</button>
            </div>
        </div>
    </div>
</template>

<script>
import ShareFunction from '../../../share-function';
export default {
    data: function () {
        return {
            initSrcImage: '/goobank_assets/common/img/avatar.png',
            member: {
                id: null,
                type: '',
                imgIdCard: '',
                imgBookBank: '',
                imgAvatar: '',
                imgBankSlip: '',
                imgCorpCert: '',
                imgDocJur: '',
            },
            isUploading: false,
        };
    },
    computed: {
        fullStoragePath() {
            return `${this.baseUrl}/${this.storagePath}`;
        },
        isPersonal() {
            return this.member.type === 'personal';
        }
    },
    mounted() {
        this.member.imgIdCard = this.baseUrl + this.initSrcImage;
        this.member.imgBookBank = this.baseUrl + this.initSrcImage;
        this.member.imgAvatar = this.baseUrl + this.initSrcImage;
        this.member.imgBankSlip = this.baseUrl + this.initSrcImage;
        this.member.imgCorpCert = this.baseUrl + this.initSrcImage;
        this.member.imgDocJur = this.baseUrl + this.initSrcImage;
    },
    methods: {
        showDocumentDetail(itemMember) {
            this.member.id = itemMember.id;
            this.member.type = itemMember.register_as;
            this.setImage('imgIdCard', itemMember.img_id_card);
            this.setImage('imgBookBank', itemMember.img_book_bank);
            this.setImage('imgAvatar', itemMember.img_avatar);
            this.setImage('imgBankSlip', itemMember.img_bank_slip);
            this.setImage('imgCorpCert', itemMember.img_corp_cert);
            this.setImage('imgDocJur', itemMember.img_doc_jur);
        },
        setImage(imgIns, imgPath) {
            if (imgPath) {
                this.member[imgIns] = /^https?:\/\//i.test(imgPath)
                    ? imgPath
                    : `${this.fullStoragePath}${imgPath}`;
            }
        },
        hideEditDoc(reloadList = false) {
            this.$emit('hideEditDoc', reloadList);
        },
        updateDocument() {
            axios.defaults.headers.common["X-CSRF-TOKEN"] = document
                .querySelector('meta[name="csrf-token"]')
                .getAttribute("content");
            const fileIdCard = this.$refs.fileIdCard;
            const fileBookBank = this.$refs.fileBookBank;
            const fileAvatar = this.$refs.fileAvatar;
            const fileBankSlip = this.$refs.fileBankSlip;
            const fileCorpCert = this.$refs.fileCorpCert;
            const fileDocJur = this.$refs.fileDocJur;
            var formData = new FormData();
            formData.append('id', this.member.id);
            formData.append('type', this.member.type);
            if (fileIdCard && fileIdCard.files.length > 0) {
                formData.append('id_card', fileIdCard.files[0]);
            }
            if (fileBookBank && fileBookBank.files.length > 0) {
                formData.append('book_bank', fileBookBank.files[0]);
            }
            if (fileAvatar && fileAvatar.files.length > 0) {
                formData.append('avatar', fileAvatar.files[0]);
            }
            if (fileBankSlip && fileBankSlip.files.length > 0) {
                formData.append('bank_slip', fileBankSlip.files[0]);
            }
            if (fileCorpCert && fileCorpCert.files.length > 0) {
                formData.append('corp_cert', fileCorpCert.files[0]);
            }
            if (fileDocJur && fileDocJur.files.length > 0) {
                formData.append('doc_jur', fileDocJur.files[0]);
            }
            var config = {
                onUploadProgress: function(progressEvent) {
                    var percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
                    console.log('percentCompleted', percentCompleted);
                }
            };
            axios.post(
                `${this.baseUrl}/admin/api/upload-member-document`,
                formData,
                config,
            )
            .then(({data}) => {
                if (data.success) {
                    alertbox('บันทึกสำเร็จ');
                    this.hideEditDoc(true);
                } else if (data.message) {
                    alertbox(data.message);
                }
            });
        },
        previewFiles(ev, target) {
            var vm = this;
            var files = event.target.files;
            if (files && files[0]) {
                if (files[0].type != 'image/png' && files[0].type != 'image/jpeg') {
                    window.alertbox('only jpg/jpeg file types are allowed', 'warning');
                    vm.resetAvatar(ev);
                    return;
                }
                var fileSize = files[0].size;
                var mbMaxSize = 5 * (1024 * 1024);
                if (fileSize > mbMaxSize) {
                    window.alertbox('Maximum allowed 5MB for uploaded files', 'warning');
                    vm.resetAvatar(ev);
                    return;
                }
                var reader = new FileReader();
                vm.isUploading = true;
                reader.onload = function(e) {
                    if (target == 'idCard') {
                        vm.member.imgIdCard = e.target.result;
                    } else if (target == 'bookBank') {
                        vm.member.imgBookBank = e.target.result;
                    } else if (target == 'avatar') {
                        vm.member.imgAvatar = e.target.result;
                    } else if (target == 'bankSlip') {
                        vm.member.imgBankSlip = e.target.result;
                    } else if (target == 'corpCert') {
                        vm.member.imgCorpCert = e.target.result;
                    } else if (target == 'docJur') {
                        vm.member.imgDocJur = e.target.result;
                    }
                    setTimeout(() => {
                        vm.isUploading = false;
                    }, 500);
                }
                reader.readAsDataURL(files[0]);
            }
        },
        previewPDFs(ev, target) {
            var vm = this;
            var files = event.target.files;
            if (files && files[0]) {
                if (files[0].type != 'application/pdf') {
                    window.alertbox('only pdf file types are allowed', 'warning');
                    vm.resetAvatar(ev);
                    return;
                }
                var fileSize = files[0].size;
                var mbMaxSize = 5 * (1024 * 1024);
                if (fileSize > mbMaxSize) {
                    window.alertbox('Maximum allowed 5MB for uploaded files', 'warning');
                    vm.resetAvatar(ev);
                    return;
                }
                var reader = new FileReader();
                vm.isUploading = true;
                reader.onload = function(e) {
                    if (target == 'corpCert') {
                        vm.member.imgCorpCert = e.target.result;
                    } else if (target == 'docJur') {
                        vm.member.imgDocJur = e.target.result;
                    }
                    setTimeout(() => {
                        vm.isUploading = false;
                    }, 500);
                }
                reader.readAsDataURL(files[0]);
            }
        },
        openImg(src) {
            ShareFunction.openImg(src);
        },
        openPDF(src) {
            ShareFunction.openPDF(src);
        },
        getTextToBtnUpload(src) {
            return (src === this.baseUrl + this.initSrcImage ? 'อัพโหลดรูป' : 'เปลี่ยนภาพ');
        },
    },
    created: function() {
    },
    props: {
        baseUrl: '',
        storagePath: '',
    },
}

</script>
<style lang="scss" scoped>
    .img-member {
        min-width: 200px;
        min-height: 200px;
        max-width: 200px;
        max-height: 200px;
    }
    // #region spin
    @-webkit-keyframes spinner-border {
        to {
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }

    @-o-keyframes spinner-border {
        to {
            -o-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }

    @keyframes spinner-border {
        to {
            -webkit-transform: rotate(360deg);
            -o-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }

    .spinner-border {
        display: inline-block;
        width: 2rem;
        height: 2rem;
        vertical-align: text-bottom;
        border: 0.25em solid currentColor;
        border-right-color: transparent;
        border-radius: 50%;
        -webkit-animation: spinner-border .75s linear infinite;
        -o-animation: spinner-border .75s linear infinite;
        animation: spinner-border .75s linear infinite;
    }

    .spinner-border-sm {
        width: 1rem;
        height: 1rem;
        border-width: 0.2em;
    }
    // #endregion spin
</style>
